const AIRTABLE_CONFIG = {
  at_app_id: 'appL6lMT4tbckRXzO',
  at_sensor_placement_form: 'https://airtable.com/appL6lMT4tbckRXzO/pagebZ6PIAlSDE9QW/form',
  at_sensor_photo_form: 'https://airtable.com/appL6lMT4tbckRXzO/pagBM1s2NyVsP4Ndg/form',
  at_govee_activation_codes_id: 'tblOrgnTt66FqoZyd',
  at_emails: 'tbl1xkB9WfaEdmplY',
  at_participants: 'tblSHAa7jTGo7OC8n',
  at_phones: 'tbl6OYIF1YfLbWrI5',
  at_phone_placements: 'tbliYjQLMVUMnzeYx',
  at_wearables: 'tblm5ku8BNAGXfyUc',
  at_wearable_placements: 'tblQgpKbUfVqymp6r',
  at_houses: 'tbli25cX9aPfKefXa',
  at_participant_placement: 'tblVmQWZkaPpTUVAD',
  at_sensors: 'tbltSSR7cS2YRiwqf',
  at_sensor_house_placement: 'tbl8yTbr3bQtLiSVx',
  at_received_sensor_files: 'tbl6X97dUu1OEENCA',
  at_bundles: 'tblJMgJ0UQQNTI9XK',
  at_issues: 'tbl4uXq8E4KZQFXxx',
  at_perceptual_surveys: 'tbl68x0ESr0kh2mAP',
  at_migrations: 'tbl13bwLPNUzEiGFI',
  at_collection_records: 'tbllFJwuxgPQYAK0D',
  at_participant_intake_forms: 'tblrA58OgDGbmvO88',
  at_house_intake_forms: 'tblZ4wuXeRBvxPMf5',
  at_pending_questions_participant_if: 'tblQNmiC2n5kEHI1z',
  at_pending_questions_house_if: 'tbltjdFChzKWRNxN6',
  at_wearable_coverage: 'tblG6AZkhJUDcOEDc',
  at_mapped_lab_report_record: 'tblRcco9xio6mA76z',
  at_received_lab_reports: 'tblAb4TdQW3RpAiPM',
  at_battery_change_records: 'tblNXtPtUdW9NtajX',
};

export default AIRTABLE_CONFIG;
